module.exports = __webpack_public_path__ + "img/fb-icon.981f26a6.svg";